<template>
  <div class="flex-grow pr-2">
    <div class="rounded-2xl p-2 pl-3 pr-3 text-left relative inline-block float-right bg-green-100 mt-3" style="min-width: 300px" :style="customWidthStyle">
      <p class="whitespace-pre-line break-words max-w-screen-sm relative">
        <span class="block tracking-widest text-xs uppercase mb-3 text-gray-600 absolute automation-message-label">
          {{ $t('conversation.whatsappTemplatedMessage')}}
        </span>
        <span v-if="whatsappMessage" class="mr-2 clear-both max-w-md" :class="{'block': textIsLong, 'inline-block pb-1': !textIsLong}"  v-linkify:options="{target: '_blank'}">
          {{whatsappMessage.attributes.text}}
        </span>
        <span class="text-xs text-gray-600 block text-right">
          <span v-if="hideStatus">
            {{ $t('conversation.justNow') }}
          </span>
          <span v-else>
            <Datetime v-bind:date="message.created_at" fromNow="true" />
          </span>
          <StatusWidget v-bind:status="message.status" class="inline-block" />
        </span>
      </p>
    </div>
  </div>
  <div class="flex-initial">
    <div class="relative h-14">
      <ChannelLabel v-if="channel" :channel="channel" asTooltip="true" />
      <MessageAgent v-bind:agentId="message.agent_id" />
    </div>
  </div>
</template>



<script>
import Datetime from '../../building_blocks/DateTime.vue'
import ChannelLabel from '../parts/ChannelLabel.vue'
import MessageAgent from '../parts/MessageAgent.vue'
import StatusWidget from '../parts/StatusWidget.vue'
import { useWhatsappMessagesStore } from '@/stores/whatsappMessageTemplates';



export default {
  name: 'WhatsappTemplatedMessage',
  props: ['message', 'channel', 'customWidthStyle', 'hideStatus', 'textIsLong'],
  setup() {
    let whatsappMessageStore = useWhatsappMessagesStore();
    return { whatsappMessageStore };
  },
  components: {
    Datetime,
    ChannelLabel,
    MessageAgent,
    StatusWidget,
  },
  computed: {
    whatsappMessage() {
      return this.whatsappMessageStore.getById(this.message.template_id);
    }
  },
}
</script>
